import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import "react-datetime/css/react-datetime.css";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Link, useNavigate } from "react-router-dom";
import DataTable from "examples/Tables/DataTable";

import tripMonitorAuthorTable from "layouts/tables/data/tripMonitorAuthorTable";
import { useEffect, useState } from "react";
import apiClient from "Utils/apiClient";
import { useMaterialUIController } from "context";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Box, Button, TextField } from "@mui/material";
import ImageModal from "components/ImageModal";
import EmptyData from "components/EmptyData";
import { useSelector } from "react-redux";
import { Email } from "@mui/icons-material";

function LongDistance() {
  const navigate = useNavigate();
  const allData = useSelector((state) => state.data.allData);
  const getUserState = useSelector((state) => state?.data?.getUserState);

  const [controller, dispatch] = useMaterialUIController();

  const [rows, setRows] = useState([]);
  const { columns } = tripMonitorAuthorTable();
  const { loggedIn } = controller;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [onClickImageData, setOnClickImageData] = useState("");
  const [checkSuperAdmin, setCheckSuperAdmin] = useState(null);
  const [adminState, setAdminState] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const handleImageClick = (url) => {
    setIsModalOpen(true);
    setOnClickImageData(url);
  };
  const onClose = () => {
    setIsModalOpen(false);
  };

  const getData = async () => {
    const getAdminData = JSON.parse(localStorage.getItem("user") || "{}");
    const getAdminState = getAdminData?.state;
    const useradmin = getAdminData?.superAdmin;

    setCheckSuperAdmin(useradmin);
    setAdminState(getAdminState);
    setLoading(true);
    setRows([]);

    try {
      const response = await apiClient.get("/trip/all");
      const tripsData = response?.data || [];
      const newRows = [];
      let index = 0;

      for (const trip of tripsData) {
        const userState = trip.state;

        // If super admin, respect the dropdown (getUserState from Redux). Otherwise, strictly use admin's own state.
        const selectedState = useradmin ? (getUserState || "All State") : getAdminState;
        const isSuperAdminAllStates = useradmin && (selectedState === "" || selectedState === "All State");
        const isSameState = userState === selectedState;
        
        const shouldIncludeUser = useradmin ? (isSuperAdminAllStates || isSameState) : (userState === getAdminState);

        if (shouldIncludeUser) {
          index++;
          const driver = trip.driverId || {};
          const driverName = `${driver.driverName || ""} ${driver.surName || ""}`.trim() || "Unknown";

          newRows.push({
            Sr: index,
            Name: driverName,
            Email: driver.email || "N/A",
            Mobile: driver.phoneNumber || "N/A",
            VehicleReg: driver.regNo || "N/A",
            State: trip.state || "Unknown",
            VehicleImage: (
              <img
                onClick={() => handleImageClick(driver.imgVehicle)}
                src={driver.imgVehicle}
                alt="vehicle"
                style={{ width: "50px", height: "50px", borderRadius: "50%", cursor: "pointer" }}
              />
            ),
            TripDate: trip.selectedDate || "N/A",
            IsMoving: (
              <Button
                variant="contained"
                className="text-white"
                sx={{
                  backgroundColor:
                    trip.status === "ACTIVE"
                      ? "green"
                      : trip.status === "COMPLETED"
                      ? "yellow"
                      : "red",
                  color: trip.status === "COMPLETED" ? "black" : "white",
                }}
              >
                {trip.status === "ACTIVE"
                  ? "Running"
                  : trip.status === "COMPLETED"
                  ? "Arrived"
                  : "Stopped"}
              </Button>
            ),
            TripType: <h5>Long Distance</h5>,
            StartRide: trip.curruntLocation || "N/A",
            EndRide: trip.finalDestination || "N/A",
          });
        }
      }

      setRows(newRows);
    } catch (error) {
      console.error("Error fetching data:", error);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user) {
      navigate("/authentication/sign-in");
    }
    getData();
  }, [allData, getUserState]);



  return (
    <DashboardLayout>
      <MDBox pt={6} pb={3}>
        <Box display="flex" justifyContent="flex-end" alignItems="center" mb={5} px={2}>
          <TextField
            label="Search by name, email and mobile"
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ width: 300 }}
          />
        </Box>
        <Grid container spacing={6} style={{ position: "relative", minHeight: "60vh" }}>
          {loading ? (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Loading...
            </div>
          ) : (
            <>
              <Grid item xs={12}>
                <Card>
                  <MDBox
                    mx={2}
                    mt={-3}
                    py={3}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                  >
                    <ToastContainer />
                    <MDTypography variant="h6" color="white">
                      {checkSuperAdmin
                        ? getUserState === ""
                          ? "All State "
                          : `${getUserState} State `
                        : `${adminState} State `}
                      Long Distance Escort
                    </MDTypography>
                  </MDBox>

                  <MDBox pt={3}>
                    {rows.length > 0 ? (
                      <DataTable
                        table={{
                          columns,
                          rows: rows.filter((row) => {
                            const search = searchTerm.toLowerCase().trim();
                            const name = row?.Name?.toLowerCase() || "";
                            const email = row?.Email?.toLowerCase() || "";
                            const mobile = row?.Mobile?.toLowerCase() || "";

                            return (
                              name.includes(search) ||
                              email.includes(search) ||
                              mobile.includes(search)
                            );
                          }),
                        }}
                        isSorted={false}
                        entriesPerPage={false}
                        showTotalEntries={false}
                        noEndBorder
                      />
                    ) : (
                      <EmptyData />
                    )}
                  </MDBox>
                </Card>
                <ImageModal
                  onClickImageData={onClickImageData}
                  onClose={onClose}
                  isModalOpen={isModalOpen}
                />
              </Grid>
            </>
          )}
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default LongDistance;
